/**
 * design_handoff_auth — the shared column shape every auth screen uses:
 * logo top-left, a 360px form column vertically centred (capped at 900px
 * per FIXES.md #9 so it holds position rather than sinking on tall
 * viewports), legal row bottom-left. Used directly by AuthCard (single
 * column) and wrapped by AuthLayout (column + right pane).
 */
import React from "react";
import { Link } from "react-router-dom";
import appConfig from "../../../../appConfig";
import styles from "./AuthColumn.module.scss";

const AuthColumn = ({ mobileExtra, children }) => {
  return (
    <div className={styles.pane}>
      <div className={styles.top}>
        <Link to="/" className={styles.logoLink}>
          <img
            src={`/img/branding/${appConfig.branding}/full_length_logo_frontier.png`}
            alt={appConfig.displayName}
            className={styles.logo}
          />
        </Link>
      </div>
      <div className={styles.middle}>
        <div className={styles.inner}>{children}</div>
      </div>
      {mobileExtra && <div className={styles.mobileExtra}>{mobileExtra}</div>}
      <div className={styles.bottom}>
        <span>© Revisual {new Date().getFullYear()}</span>
        <a href={appConfig.pp_link} target="_app-pp">
          Privacy Policy
        </a>
        <a href={appConfig.tos_link} target="_app-tos">
          Terms of Service
        </a>
      </div>
    </div>
  );
};

export default AuthColumn;
